import { render, staticRenderFns } from "./assets-page.vue?vue&type=template&id=428dec15&scoped=true"
import script from "./assets-page.vue?vue&type=script&lang=ts"
export * from "./assets-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428dec15",
  null
  
)

export default component.exports